import { warn } from '../utils/console'
import { StepType } from './PaymentProgress'

export const calcPercent = (_step: StepType, _maxStep: StepType): number => {
  const step = parseInt(`${_step}`)
  const maxStep = parseInt(`${_maxStep}`)
  if (Number.isNaN(step) || Number.isNaN(maxStep)) {
    warn('The value of "step" or "maxStep" property is invalid, please provide numerical number or string')
    return 0
  }
  if (step > maxStep) {
    warn('The value of "step" is greater than that of "maxStep"')
    return 0
  }

  return (step / maxStep) * 100
}
